import React, { VFC } from 'react'

import { ImageV2 } from '@Components/Image'
import { NavigationEvent } from '@Events/Navigation'
import { LinkedProduct } from '@Globals/CMS/ProductHelpers'

import {
  LinkedProductCheckmark, LinkedProductContent,
  LinkedProductImageContainer,
  LinkedProductRoot,
} from './LinkedProduct.styled'

interface Props extends LinkedProduct {
  isSelected?: boolean
  setTitle: (string?) => void
  type: string
}

// TODO: selector implementation.
export const LinkedProductItem: VFC<Props> = ({
  image,
  isSelected,
  productID,
  setTitle,
  title,
  type,
  url,
}) => (
  <LinkedProductRoot
    key={productID}
    event={new NavigationEvent({
      attributes: {
        dest_page_type: 'product',
        dest_page_type_id: productID,
        source_id: `linked_products_${type}`,
      },
      eventName: 'nav_link_click',
    })}
    href={url}
    onMouseOut={() => setTitle()}
    onMouseOver={() => setTitle(title)}
  >
    <LinkedProductContent isSelected={isSelected}>
      <LinkedProductImageContainer>
        <ImageV2
          alt={title}
          height={80}
          src={image}
          width={80}
        />
      </LinkedProductImageContainer>
      {isSelected && <LinkedProductCheckmark />}
    </LinkedProductContent>
  </LinkedProductRoot>
)

